var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-icon",class:{ 'is-active': _vm.value },on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }